import type { MailboxInfo } from 'owa-client-types';
import getStore from '../store/store';
import { resetLocalOverrides } from '../utils/setLocalOverride';
import { applicationSettingsOverridesChanged } from './applicationSettingsOverridesChanged';

export default function resetApplicationSettingOverridesAction(mailboxInfo?: MailboxInfo): void {
    resetLocalOverrides(mailboxInfo);
    getStore(mailboxInfo).overrides = {};
    applicationSettingsOverridesChanged(mailboxInfo);
}
